import { detectDupes } from "@liveblocks/core";

import { PKG_FORMAT, PKG_NAME, PKG_VERSION } from "./version";

detectDupes(PKG_NAME, PKG_VERSION, PKG_FORMAT);

export type {
  Awaitable,
  BaseActivitiesData,
  BaseMetadata,
  BaseUserMeta,
  BroadcastOptions,
  Client,
  ClientOptions,
  CommentAttachment,
  CommentBody,
  CommentBodyBlockElement,
  CommentBodyElement,
  CommentBodyInlineElement,
  CommentBodyLink,
  CommentBodyLinkElementArgs,
  CommentBodyMention,
  CommentBodyMentionElementArgs,
  CommentBodyParagraph,
  CommentBodyParagraphElementArgs,
  CommentBodyText,
  CommentBodyTextElementArgs,
  CommentData,
  CommentLocalAttachment,
  CommentMixedAttachment,
  CommentReaction,
  EnsureJson,
  History,
  HistoryVersion,
  Immutable,
  InboxNotificationData,
  IUserInfo,
  Json,
  JsonArray,
  JsonObject,
  JsonScalar,
  LargeMessageStrategy,
  LiveblocksErrorContext,
  LiveListUpdate,
  LiveMapUpdate,
  LiveObjectUpdate,
  LiveStructure,
  LostConnectionEvent,
  Lson,
  LsonObject,
  NotificationChannel,
  NotificationChannelSettings,
  NotificationKind,
  NotificationSettings,
  OthersEvent,
  PlainLsonObject,
  ResolveMentionSuggestionsArgs,
  ResolveRoomsInfoArgs,
  ResolveUsersArgs,
  Room,
  RoomSubscriptionSettings,
  Status,
  StorageStatus,
  StorageUpdate,
  StringifyCommentBodyElements,
  StringifyCommentBodyOptions,
  ThreadData,
  ToImmutable,
  UploadAttachmentOptions,
  User,
} from "@liveblocks/core";
export {
  createClient,
  defineAiTool,
  getMentionsFromCommentBody,
  isNotificationChannelEnabled,
  LiveblocksError,
  LiveList,
  LiveMap,
  LiveObject,
  shallow,
  stringifyCommentBody,
  toPlainLson,
} from "@liveblocks/core";
